import Config from '../Config';

const APP_CONFIG_SET_ACTION = 'APP_CONFIG_SET';

export function appConfigDefaultState() {
  return null;
}

export async function getAppConfig(dispatch) {
  const result = await fetch(`${Config.apiGateway.URL}/app-config`);
  let payload = await result.json();
  payload = {
    maintenanceMode: payload.maintenance_mode,
    appVersion: payload.app_version,
    enabledSupportButtons: payload.enabled_support_buttons,
    helpSupportLanguages: payload.help_support_languages,
    appClientId: payload.app_client_id,
    userPoolId: payload.user_pool_id,
    reactAppCookieDomain: payload.react_app_cookie_domain,
    requiredAccessRoles: payload.app_config_required_access_roles
  };
  sessionStorage.setItem('appClientId', payload.appclientId);
  dispatch({
    type: APP_CONFIG_SET_ACTION,
    payload
  });
}

export default (state = appConfigDefaultState(), action) => {
  const { payload, type } = action;
  switch (type) {
    case APP_CONFIG_SET_ACTION:
      return payload;

    default:
      return state;
  }
};
